import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChecklistSummaryModule } from './checklist-summary/checklist-summary.module';
import { CreateDeliveryChecklistModule } from './create-delivery-checklist/create-delivery-checklist.module';
import { VinLookupModule } from './vin-lookup/vin-lookup.module';

const routes: Routes = [
  {
      path: '',
      children: [
        {
          path: '',
          redirectTo: 'summary',
          pathMatch: 'full'
      },
      {
        path: 'summary',
        loadChildren: () => ChecklistSummaryModule
      },
      {
        path: 'createChecklist',
        loadChildren: () => CreateDeliveryChecklistModule
      },
      {
        path: 'vinlookup',
        loadChildren: () => VinLookupModule
      }
      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeliveryChecklistRoutingModule { }
